export default __webpack_public_path__ + "static/media/upload.9e2e539a.svg";